import { createContext, ReactNode } from 'react';
import { api } from '../server/api';
import { IPostValidationPublication } from '../interfaces/IPostValidation';

interface PostValidationContextProviderProps {
  children: ReactNode;
}

interface PostValidationContextProps {
  getPlayerPublications: () => Promise<
    IPostValidationPublication[] | undefined
  >;
  getPlayerPublicationById: (
    id: string
  ) => Promise<IPostValidationPublication | undefined>;
  createSubmission: (body: {
    publicationId: string;
    socialMedia: string;
    screenshotUrls: string[];
  }) => Promise<any>;
  uploadScreenshot: (file: File) => Promise<string | undefined>;
}

export const postValidationContext = createContext(
  {} as PostValidationContextProps
);

export function PostValidationContextProvider(
  props: PostValidationContextProviderProps
) {
  async function getPlayerPublications(): Promise<
    IPostValidationPublication[] | undefined
  > {
    try {
      const response = await api.get('/post-validation/publications/player');
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('getPlayerPublications error: ', error);
    }
  }

  async function getPlayerPublicationById(
    id: string
  ): Promise<IPostValidationPublication | undefined> {
    try {
      const response = await api.get(
        `/post-validation/publications/player/${id}`
      );
      if (response.data.error) {
        throw new Error();
      }
      return response.data.body;
    } catch (error) {
      console.log('getPlayerPublicationById error: ', error);
    }
  }

  async function createSubmission(body: {
    publicationId: string;
    socialMedia: string;
    screenshotUrls: string[];
  }): Promise<any> {
    const response = await api.post('/post-validation/submissions', body);
    if (response.data.error) {
      throw response.data.message;
    }
    return response.data.body;
  }

  async function uploadScreenshot(file: File): Promise<string | undefined> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(
      '/file-upload/post-validation-screenshot',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.data.error) {
      throw response.data.message;
    }

    return response.data.body;
  }

  return (
    <postValidationContext.Provider
      value={{
        getPlayerPublications,
        getPlayerPublicationById,
        createSubmission,
        uploadScreenshot,
      }}
    >
      {props.children}
    </postValidationContext.Provider>
  );
}
